<ion-button
  class="{{ buttonType }} {{ buttonAlign }}"
  (click)="onClick()"
  [disabled]="disabled"
  [ngStyle]="{ width: width }"
>
  @if (showSpinner) {
    <ion-label>
      <ion-spinner name="dots"></ion-spinner>
    </ion-label>
  } @else {
    <ion-label>{{ text | translate }}</ion-label>
    @if (icon) {
      <ion-icon [name]="icon" slot="end"></ion-icon>
    }
  }
</ion-button>
